export default __webpack_public_path__ + "img/2127c86608b8889f4a9da69193f77056.gif";